import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

const commonPadding = css`
  padding: 16px 0;
`;

export const CaptionWrapper = styled.div`
  ${commonPadding}
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const RejectWrapper = styled.div`
  ${theme('commonPadding')}
  background-color: ${palette('red_opacity_100')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: self-start;
`;

export const GuideWrapper = styled.div`
  ${commonPadding}
  text-align: start;
`;
